import React from "react";
import PageHero from "../components/PageHero";
import ContactForm from "../components/ContactForm";
import { Seo } from "../components/Seo";
import { RelatedServices } from "../components/RelatedServices";
import { IconFeatureCard, SectionIntro } from "../components/IconFeatureCard";
import { managedServices, images } from "../mock";

const MsIntro = () => (
  <section className="py-20">
    <div className="container-wide max-w-3xl mx-auto text-center">
      <p className="text-lg text-slate-500 leading-relaxed">
        IT managed services involve outsourcing the responsibility for managing, maintaining and supporting your IT infrastructure to a trusted Managed Service Provider (MSP). We handle the technical aspects under a clear agreement, so your team can focus on what matters most.
      </p>
    </div>
  </section>
);

const MsGrid = () => (
  <section className="pb-20">
    <div className="container-wide">
      <SectionIntro eyebrow="What's Included" title="Comprehensive managed IT" />
      <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {managedServices.map((s) => (
          <IconFeatureCard key={s.title} icon={s.icon} title={s.title} body={s.body} />
        ))}
      </div>
    </div>
  </section>
);

const SubscriptionBand = () => (
  <section className="py-16 bg-slate-900 text-white relative overflow-hidden">
    <div className="absolute -top-24 -right-24 h-72 w-72 rounded-full bg-primary/20 blur-3xl" />
    <div className="container-wide relative max-w-3xl mx-auto text-center">
      <h2 className="font-display text-2xl sm:text-3xl font-extrabold text-balance">Predictable costs, scalable resources</h2>
      <p className="mt-4 text-slate-300 leading-relaxed">
        Managed services are delivered on a subscription basis, with pricing based on the number of devices, users or specific services provided. This gives you predictable costs and lets you scale your IT resources without investing heavily in in-house staff and infrastructure.
      </p>
    </div>
  </section>
);

const MsContact = () => (
  <section id="contact" className="py-20 bg-slate-50">
    <div className="container-wide">
      <div className="max-w-2xl mx-auto text-center mb-12">
        <span className="inline-block text-xs font-semibold uppercase tracking-[0.18em] text-primary mb-3">Contact Us</span>
        <h2 className="font-display text-3xl sm:text-4xl font-extrabold text-slate-900">Drop us a line!</h2>
      </div>
      <ContactForm compact source="Managed Services" />
    </div>
  </section>
);

const ManagedServicesPage = () => (
  <div>
    <Seo
      title="Managed IT Services — 24/7 Monitoring, Security & Support | OzzieeTech"
      description="Outsource your IT with confidence: 24/7 proactive monitoring, cybersecurity, backup & recovery and responsive helpdesk support on a predictable monthly plan."
      path="/managed-services"
    />
    <PageHero
      eyebrow="Managed Services"
      title="IT Managed Services"
      sub="Outsource the management, maintenance and support of your IT infrastructure so you can focus on your core business."
      image={images.managed}
    />
    <MsIntro />
    <MsGrid />
    <SubscriptionBand />
    <RelatedServices current="/managed-services" />
    <MsContact />
  </div>
);

export default ManagedServicesPage;
